import { Component } from '@angular/core';

import { ModalController, NavParams, Platform } from '@ionic/angular/standalone';
import { Market } from '@awesome-cordova-plugins/market/ngx';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { ButtonComponent } from '@en-voiture-simone/seemone/components/button';
import { VersionMessage } from '@app/models/version-message';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'modal-version-update-component',
  templateUrl: 'modal-version-update.component.html',
  styleUrls: ['modal-version-update.component.scss'],
  host: { class: 'legacy-styles' },
  imports: [ButtonComponent],
})
export class ModalVersionUpdateComponent {
  message: string;
  action: string;
  ctaName: string = 'Mettre à jour';
  forceUpdate: boolean = false;

  constructor(
    private navParams: NavParams,
    private platform: Platform,
    private market: Market,
    private inAppBrowser: InAppBrowser,
    private modalController: ModalController
  ) {
    const versionMessage: VersionMessage = this.navParams.get('versionMessage');
    if (versionMessage) {
      this.message = versionMessage.message;
      this.action = versionMessage.action;
      this.ctaName = versionMessage.cta_name;
      this.forceUpdate = versionMessage.force_update;
    }
  }

  async closeModal() {
    await this.modalController.dismiss();
  }

  async goToStore() {
    // If action is to redirect to store, do it regardless of forceUpdate
    if (this.action === 'SplashMessageRedirectingToStore') {
      await this.redirectToStore();
      return;
    }

    // If not forcing update, dismiss modal
    if (!this.forceUpdate) {
      await this.modalController.dismiss();
      return;
    }

    // Handle SplashMessage action
    if (this.action === 'SplashMessage') {
      if (!this.platform.is('cordova')) {
        window.location.reload();
      }
      await this.modalController.dismiss();
    }
  }

  private async redirectToStore() {
    if (!this.platform.is('cordova')) {
      const splashUrl =
        environment.env === 'production'
          ? 'https://app.envoituresimone.com/splash'
          : 'https://app-dev.envoituresimone.com/splash';
      window.open(splashUrl, '_blank');
      return;
    }

    if (this.platform.is('ios')) {
      try {
        this.inAppBrowser.create('itms-apps://itunes.apple.com/app/id1448880045', '_system');
      } catch (error) {
        try {
          await this.market.open('id1448880045');
        } catch (marketError) {
          this.inAppBrowser.create('https://apps.apple.com/app/id1448880045', '_system');
        }
      }
      return;
    }

    if (this.platform.is('android')) {
      try {
        await this.market.open('com.envoituresimone.app');
      } catch (error) {
        console.error('Market plugin error:', error);
      }
    }
  }
}
